var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH76(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{mix-blend-mode:screen;}.cls-1,.cls-3{fill:none;stroke:#ffd15c;stroke-linecap:round;stroke-linejoin:round;stroke-width:34.02px;}.cls-2{fill:#ffd15c;}.cls-4{fill:#fff;opacity:0;}.cls-5{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.09,129.71c-9.83,18.97-29.65,31.94-52.5,31.94-10.26,0-19.91-2.61-28.31-7.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "49.51 172.76 45.95 122.75 97.64 126.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.19,75.8c9.67-19.46,29.75-32.84,52.96-32.84,10.26,0,19.91,2.61,28.31,7.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "153.23 31.85 156.79 81.85 105.1 78.58"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 155.44,
    cy: 80.85,
    r: 15.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.9,
    cy: 123.31,
    r: 15.13
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH76);
export default __webpack_public_path__ + "static/media/H76.9845f8c9784f58626c16b9d5f372afd5.svg";
export { ForwardRef as ReactComponent };